import { gql } from '@apollo/client';
import { CoreUser } from 'src/models/user/fragments';

export const fetchMe = gql`
  ${CoreUser}
  query Me {
    me {
      ...CoreUser
    }
  }
`;

export const fetchUser = gql`
  ${CoreUser}
  query User($id: ID!) {
    user(id: $id) {
      ...CoreUser
    }
  }
`;

export const fetchUserFriends = gql`
  {
    userFriends {
      _id
      email
      fullName
      enableChat
      avatar
      facebookId
      isPro
    }
  }
`;

export const fetchUsersWithFacebookID = gql`
  ${CoreUser}
  query UsersFB($facebookIds: [ID!]!) {
    usersFB(facebookIds: $facebookIds) {
      ...CoreUser
    }
  }
`;

export const findUser = gql`
  ${CoreUser}
  query FindUser($value: String!) {
    findUser(value: $value) {
      ...CoreUser
    }
  }
`;

export const fetchUsers = gql`
  ${CoreUser}
  query users {
    users {
      ...CoreUser
    }
  }
`;

export const getUsersWithRequests = gql`
  ${CoreUser}
  query getUsersWithRequests {
    getUsersWithRequests {
      ...CoreUser
    }
  }
`;
